"use strict";

/*!
 * Скрипт виджета новых фич
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var defaultOptions = {};

  // ReSharper disable once InconsistentNaming
  var NewFeaturesWidget = function NewFeaturesWidget() {
    var options = {
      itemsCount: null
    };
    var me;
    this.option = function (name, value) {
      if (name) {
        if (!value) {
          return options[name];
        }
        options[name] = value;
      }
    };
    this.centerModals = function centerModals() {
      var $clone = me.clone().css('display', 'block').appendTo('body');
      var top = Math.round(($clone.height() - $clone.find('.modal-content').height()) / 2);
      top = top > 0 ? top : 0;
      $clone.remove();
      me.find('.modal-content').css("margin-top", top);
    };
    this.closeModal = function () {
      $.ajax({
        url: options.updateStatusUrl,
        type: 'POST',
        cache: false
      });
    };
    this.init = function (opt) {
      options = $.extend({}, defaultOptions, opt);
      var that = this;
      $.ajax({
        url: options.getFeaturesUrl,
        cache: false,
        dataType: 'html',
        success: function success(data) {
          if (data != null) {
            $('#newFeaturesContainer').html(data);
            me = $('#newFeaturesModal');
            if (me.length > 0) {
              $.b2b.carousel.init({
                widget: me.find('.carousel')
              });
              me.modal({
                backdrop: 'static',
                keyboard: false,
                show: false
              }).on('shown.bs.modal', $.b2b.carousel.onWindowResize).on('show.bs.modal', that.centerModals).on('hide.bs.modal', that.closeModal);
              me.modal('show');
              $(window).on('resize', that.centerModals);
              me.find('.carousel').on('carousel.slide', function (event, value) {
                var feature = $($(this).find('ul.items li.item')[value]);
                me.find('#featureTitle').html(feature.find('span.hidden').html());
              });
            }
          }
        }
      });
    };
  };
  $.b2b.newFeaturesWidget = new NewFeaturesWidget();
})(jQuery);